import { Routes, Route } from 'react-router-dom';
import OpenPositions from './pages/positions/Positions';
import Application from './pages/application/Application';
import Submitted from './pages/submitted/Submitted';
import Banner from './components/Banner';

const App = () => {
  return (
    <>
      <Banner
        message="Durin digs up $3.4M to automate drills for critical minerals exploration"
        linkText="Learn More"
        linkUrl="https://techcrunch.com/2025/04/23/durin-digs-up-3-4m-to-automate-drills-for-critical-minerals-exploration/"
      />
      <Routes>
        <Route path="/" element={<OpenPositions />} />
        <Route path="/:applicationId" element={<Application />} />
        <Route path="/submitted" element={<Submitted />} />
      </Routes>
    </>
  );
};

export default App;